import styled, { StyledComponent } from 'styled-components'
import Description from './Description'
import Group from './Group'
import Heading from './Heading'
import { Views } from '../../../enums'

const Body = styled.div<BodyProps>`
  padding-right: 20px;
  margin-top: 10px;
  margin-right: 40px;
  margin-bottom: 10px;
  margin-left: 40px;
  ${({ view }) => view !== Views.default && `
    height: 520px;
    overflow-x: auto;
    @media(max-width: 767px) {
      max-height: 50%;
      height: auto;
    }
  `}
  @media(max-width: 767px) {
    margin-top: 0;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
  }
` as Body

Body.Description = Description
Body.Group = Group
Body.Heading = Heading

export default Body

type Body = StyledComponent<'div', BodyProps, any> & {
  Description: StyledComponent<'p', any>
  Group: StyledComponent<'div', any>
  Heading: StyledComponent<'p', any>
}

interface BodyProps {
  view: Views
}


